import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
const TITLE = "Konversi IPK ke Sistem Australia";
const DESCRIPTION =
  "Temukan cara mengkonversi IPK Anda ke sistem Australia dengan mudah dan akurat. Pelajari detail sistem penilaian universitas Australia.";
const KEYWORDS =
  "sistem universitas Australia, konversi IPK universitas, sistem nilai Australia, nilai sarjana, nilai magister, IPK universitas, Australia";
const OG_URL = "https://do-calculate.com/calculator/id/gradetoaustralia";
function GradeToAustralia() {
  const [originalValue, setOriginalValue] = useState("");
  const [convertedValue, setConvertedValue] = useState("");
  const [conversionType, setConversionType] = useState("grade");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const gpaToAustralianGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "HD";
    } else if (gpa >= 3.5 && gpa < 4.0) {
      return "D";
    } else if (gpa >= 3.0 && gpa < 3.5) {
      return "CR";
    } else if (gpa >= 2.5 && gpa < 3.0) {
      return "P";
    } else if (gpa >= 2.0 && gpa < 2.5) {
      return "P-";
    } else {
      return "Input tidak valid";
    }
  };
  const calculateGrade = (value) => {
    if (conversionType === "grade") {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (grade / 25).toFixed(2);
      }
    } else if (conversionType === "gpa") {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToAustralianGrade(gpa);
      }
    }
    return "Input tidak valid";
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue("");
    setConvertedValue("");
    setShowResult(false);
    setError(null);
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Temukan cara mengkonversi IPK Anda (persentase atau IPK) ke sistem Australia dengan mudah dan akurat. Pelajari detail sistem penilaian universitas Australia menggunakan alat yang berguna ini.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    Konversi IPK Universitas ke Sistem Australia
                  </h2>
                </div>
                <hr />
                <div className="form-group">
                  <b>
                    <label>Jenis Nilai:</label>
                  </b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === "grade"}
                      onChange={() => handleConversionTypeChange("grade")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gradeConversion"
                      className="form-check-label"
                    >
                      Persentase (100)
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === "gpa"}
                      onChange={() => handleConversionTypeChange("gpa")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">
                      IPK (4.00)
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="originalValue">
                        {conversionType === "grade"
                          ? "Nilai Persentase:"
                          : "IPK:"}
                      </label>
                    </b>
                    <input
                      type="text"
                      value={originalValue}
                      id="originalValue"
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className="form-control"
                      style={{ width: "200px", marginRight: "4px" }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button
                  className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  Hitung
                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Error:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {showResult &&  (
                  <div
                    style={{ fontSize: "15px" }}
                    className="bg-light bg-gradient text-dark"
                  >
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>Hasil:</strong>
                    </div>
                    <b>
                      {conversionType === "grade"
                        ? `Nilai Persentase dalam Sistem Australia: ${convertedValue}`
                        : `Nilai Australia untuk IPK: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Sistem Klasifikasi Nilai Universitas di Australia
                    </h2>
                  </u>
                  <p>
                    Di Australia, nilai diklasifikasikan pada skala dari HD hingga F, dengan HD adalah yang terbaik dan F adalah yang terburuk. Nilai dapat dibagi sebagai berikut:
                  </p>
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>IPK (Skala 4 Poin)</th>
                        <th>Nilai Australia</th>
                        <th>Persentase Setara</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>4.0</td>
                        <td>HD</td>
                        <td>85-100%</td>
                      </tr>
                      <tr>
                        <td>3.5 - 3.9</td>
                        <td>D</td>
                        <td>75-84%</td>
                      </tr>
                      <tr>
                        <td>3.0 - 3.4</td>
                        <td>CR</td>
                        <td>65-74%</td>
                      </tr>
                      <tr>
                        <td>2.5 - 2.9</td>
                        <td>P</td>
                        <td>50-64%</td>
                      </tr>
                      <tr>
                        <td>2.0 - 2.4</td>
                        <td>P-</td>
                        <td>45-49%</td>
                      </tr>
                      <tr>
                        <td>0.0 - 1.9</td>
                        <td>F</td>
                        <td>0-44%</td>
                      </tr>
                    </tbody>
                   </table>
                  <p>
                    Informasi ini membantu memahami cara mengkonversi nilai ke sistem Australia dan mengetahui persentase setaranya.
                  </p>
                  <b className="text-primary">
                    <span>Contoh: </span>
                    Jika Anda memiliki IPK 3.0 pada skala 4.0, Anda dapat mengkonversinya ke sistem Australia menggunakan alat di atas dan Anda akan mendapatkan hasil yang setara.
                  </b>
                  <p>
                    Alat ini sangat berguna bagi mahasiswa internasional yang ingin melanjutkan studi di Australia atau melamar pekerjaan yang membutuhkan IPK tertentu.
                  </p>
                  <div>
                    <p>
                      Australia adalah salah satu negara yang terus mengalami perkembangan ilmiah, dengan banyak universitas ternama yang menjadi tujuan mahasiswa dari seluruh dunia.
                    </p>
                    <p className="alert alert-info">
                      Di Australia terdapat banyak universitas yang terakreditasi secara global, dan sistem studi di universitas Australia dikenal dengan ketelitian ilmiah dan kebaruan kurikulum. Biaya studi di Australia juga relatif terjangkau dibandingkan dengan negara-negara Eropa lainnya dan Amerika Serikat.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GradeToAustralia;